//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Footer from '../components/footer.vue'
import {
    SaunaKanbanQuery,
    MemberKanbanQuery
} from '../../static/js/api.js'

function loadtotal(that) {


    SaunaKanbanQuery({}, function (res) {
        console.log(res)
        if (res.data.IsSuccess) {

            that.data = JSON.parse(res.data.Result)


            var data=JSON.parse(res.data.Result).PayModeDetails


            var obj={},newArr=[];
            var newData=[];
            data.forEach(function(item,suffix){
                //根据对象的属性是唯一的，将值作为对象的属性名
                if(!obj[item.GroupName]){
                    var arr=[];
                    arr.push(item);
                    newArr.push(arr);
                    obj[item.GroupName]=item;
                }else{
                    newArr.forEach(function(value,index){
                        //如果已经存在  就循环新组的值将值插入属性相同的数组里   为了防止重复添加   只要和第一个比较就可以了
                        if(value[0].GroupName==item.GroupName){
                            value.push(item)
                        }
                    })
                }



            })
            console.log(obj);



            for(var i=0;i<newArr.length;i++){
                var total={
                    GroupName: newArr[i][0].GroupName,
                    PayModeName:"【"+ newArr[i][0].GroupName+"合计"+"】",
                    OffsetMoney: 0,
                    MarkCount: 0,
                    Money: 0,


                }
                for(var k=0;k<newArr[i].length;k++){

                    total.OffsetMoney+=newArr[i][k].OffsetMoney
                    total.MarkCount+=newArr[i][k].MarkCount
                    total.Money+=newArr[i][k].Money

                  
                }
                  total.OffsetMoney = total.OffsetMoney.toFixed(2)
                    total.MarkCount = total.MarkCount.toFixed(0)
                    total.Money = total.Money.toFixed(2)
                newArr[i].push(total)


            }

            var sortArr=[]
            for(var j=0;j<newArr.length;j++){

                var wordIndex=newArr[j][0].GroupName.substring(0,1)
                if(sortArr.length!=0){

                    var same=false

                    for(var m=0;m<sortArr.length;m++){
                        if(sortArr[m].word==wordIndex){
                            same=true
                        }


                    }

                    if(!same){
                        sortArr.push({
                            word:wordIndex,
                            index:newArr[j]
                        })
                    }


                }else{
                    sortArr.push({
                        word:wordIndex,
                        index:newArr[j]
                    })
                }



            }


            var newArrs=sortArr.sort(compare);
            function compare(a,b){
                return   a.word.charCodeAt(0) - b.word.charCodeAt(0)
            }


            console.log(newArrs)

            var  lastArr=[]
            for(var l=0;l<newArrs.length;l++){
                lastArr.push(newArrs[l].index)



            }




            that.data.PayModeDetails=lastArr


            MemberKanbanQuery({}, function (ress) {
                console.log(ress)
                if (ress.data.IsSuccess) {

                    that.data.PayDetails = JSON.parse(ress.data.Result).PayDetails
                    console.log(that.data)
                } else {

                    that.$vux.toast.text('数据获取失败，请重试', 'middle')

                }


            })



            that.loading=false

            console.log(that.data)
        } else {

            that.$vux.toast.text('数据获取失败，请重试', 'middle')

        }


    })

}


export default {
    name: 'app',
    components: {
        'pc-footer': Footer,
    },
    data() {
        return {
            loading:true,
            data: {
                GuestFlows: {},
                BarConsumeDetails: {},
                BarConsumeSummary: {},
                ConsumeDetails: {},
                ConsumeSummary: {},
                GuestPerConsume: {},
                HandCardUsed: {},
                MemberUsedDetail: {},
                MemberUsedSummary: {},
                NewMemberDetails: {},
                NewMemberSummary: {},
                PayModeDetails: {},
                PayModeSummary: {
                    Money:1
                },
                PrepaidMemberDetails: {},
                PrepaidMemberSummary: {},
                PayDetails: {},

            },
            selected:1,
            selectedsr:1,
            msg: 'Welcome to Your Vue.js App',
            nav:[
                {
                    id:1,
                    name:"人数统计"

                },
                {
                    id:2,
                    name:"收入情况"

                },
                {
                    id:3,
                    name:"销售类别"

                },{
                    id:4,
                    name:"吧台统计"

                }

            ],
            navsr:[

               {
                    id:1,
                    name:"营业付款"

                }


            ]
        }
    },

    created() {
        var that = this
        loadtotal(that)


    },
    methods:{

        refresh(){
            this.loading=true
            var that=this
            loadtotal(that)


        },
        change(index){
            console.log(index)
            this.selected= parseInt(index+1)

        },

        changesr(index){
            console.log(index)
            this.selectedsr= parseInt(index+1)

        }


    }

}



// WEBPACK FOOTER //
// ./src/pages/mainclass1.vue